export default {
  CREATE_PRODUCTS (state, item) {
    state.products.unshift(item)
  },
 
  SET_PRODUCTS (state, products) {
    state.products = products
  },

  UPDATE_PRODUCTS (state, product) {
    const productIndex = state.products.findIndex((p) => p.id === product.id)
    Object.assign(state.products[productIndex], product)
  }
}
